import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// Multi-select combobox with search + select all / clear all.
// options: [{value, label, keywords?}], value: string[], onChange(string[])
export function MultiSelect({ options, value, onChange, placeholder = "Seleziona...", allLabel = "Tutti", testid }) {
  const [open, setOpen] = useState(false);
  const selected = value || [];
  const toggle = (v) => onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  const label = selected.length === 0 ? allLabel : selected.length === 1
    ? (options.find((o) => o.value === selected[0])?.label || "1 selezionato")
    : `${selected.length} selezionati`;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" data-testid={testid} className="h-10 w-full justify-between rounded-md font-normal">
          <span className="truncate">{label}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] max-w-[calc(100vw-2rem)] p-0" align="start">
        <div className="flex items-center gap-2 border-b border-slate-100 p-2">
          <Button size="sm" variant="ghost" className="h-7 flex-1 text-xs" data-testid={`${testid}-select-all`} onClick={() => onChange(options.map((o) => o.value))}>Seleziona tutto</Button>
          <Button size="sm" variant="ghost" className="h-7 flex-1 text-xs" data-testid={`${testid}-clear`} onClick={() => onChange([])}>Deseleziona tutto</Button>
        </div>
        <Command>
          <CommandInput placeholder={placeholder} data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>Nessun risultato</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.value} value={`${o.label} ${o.keywords || ""} ${o.value}`} onSelect={() => toggle(o.value)} data-testid={`${testid}-opt-${o.value}`}>
                  <div className={cn("mr-2 flex h-4 w-4 items-center justify-center rounded border", selected.includes(o.value) ? "border-[#002FA7] bg-[#002FA7] text-white" : "border-slate-300")}>
                    {selected.includes(o.value) && <Check className="h-3 w-3" />}
                  </div>
                  <span className="truncate">{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
